import { render, staticRenderFns } from "./editManager.vue?vue&type=template&id=c1b10856&scoped=true"
import script from "./editManager.vue?vue&type=script&lang=ts"
export * from "./editManager.vue?vue&type=script&lang=ts"
import style0 from "./editManager.vue?vue&type=style&index=0&id=c1b10856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b10856",
  null
  
)

export default component.exports